// extracted by mini-css-extract-plugin
export default {"eventDescription":"OqrOM","sideBySide":"waDwS","descriptionSpacing":"F44CO"};